exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mouse-action-section {\n  position: relative;\n}\n.selection-section {\n  position: absolute;\n  border: 1px solid rgba(33, 113, 219, 0.6);\n  background: rgba(75, 141, 228, 0.2);\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/views/selection.vue
 ** module id = 56
 ** module chunks = 0
 **/